import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useCommandeListTable } from "./hooks/useCommandeListTable";
import { CommandeListHeader } from "./components/listTable/CommandeListHeader";
import { CommandeListRows } from "./components/listTable/CommandeListRows";
import { CommandeContextMenu, CommandeDeleteToasts } from "./components/listTable/CommandeListOverlays";

// Boîte de réception des commandes : en-tête, lignes regroupées par jour, menu contextuel et suppressions différées.
export default function CommandeListTable({
    commandes,
    totalElements,
    page,
    totalPages,
    setPage,
    onSelect,
    onEdit,
    selectedCommandeId = null,
    onRefresh,
    onCreate,
    showStatut = false,
    readOverrides = {},
    onFlagChange,
    searchContent = null,
    filtersContent = null,
    searchQuery = "",
    showPagination = true,
    onOpenFilters = null,
    onOpenLabels = null,
    hasActiveFilters = false,
    activeFilterCount = 0,
}) {
    const { isMobile, isTablet } = useBreakpoint();
    const list = useCommandeListTable({ commandes, onSelect, onEdit, selectedCommandeId, onRefresh, onFlagChange });
    const { contextMenu, getFlag } = list;
    const contextMenuRead = contextMenu ? getFlag(contextMenu.cmd, "read") : false;

    return (
        <div
            ref={list.containerRef}
            tabIndex={0}
            onKeyDown={list.handleKeyDown}
            className="commande-inbox"
            style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, background: "#f4f1ea", outline: "none" }}
        >
            <CommandeListHeader
                layout={{ isMobile, isCompact: isMobile || isTablet }}
                header={{ totalElements, showStatut, searchContent, isRefreshing: list.isRefreshing, onRefresh: list.handleRefresh, onCreate }}
                toolbar={{ filtersContent, onOpenLabels, onOpenFilters, hasActiveFilters, activeFilterCount }}
                pagination={{ showPagination, page, totalPages, setPage }}
            />

            <CommandeContextMenu
                contextMenu={contextMenu}
                isRead={contextMenuRead}
                onToggleRead={() => {
                    list.patchFlags(contextMenu.cmd.id, { read: !contextMenuRead });
                    list.closeContextMenu();
                }}
                onDelete={() => list.handleDelete(contextMenu.cmd)}
            />

            <CommandeListRows
                commandes={commandes}
                pendingDeletes={list.pendingDeletes}
                rowState={{ readOverrides, getFlag, focusedIndex: list.focusedIndex, selectedCommandeId }}
                showStatut={showStatut}
                searchQuery={searchQuery}
                handlers={{
                    onContextMenu: list.openContextMenu,
                    onStarClick: list.handleStarClick,
                    onRowClick: list.handleRowClick,
                    onEdit,
                }}
            />

            <CommandeDeleteToasts pendingDeletes={list.pendingDeletes} onCancel={list.cancelDelete} />
        </div>
    );
}
